import React, { useEffect } from "react";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import { useForm, Controller } from "react-hook-form";
import { numberRegex } from "../../../core/utils/tools";

const CreateOrEditAmusementGroup = ({ showModalGroup, setShowModalGroup, selectedGroupId }) => {
  // let location = useLocation();
  // let history = useHistory();
  // let back = (e) => {
  //     e.stopPropagation();
  //     history.goBack();
  // };
  const handleClose = () => {
    setShowModalGroup(false);
  };
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
  } = useForm({ defaultValues: { id: 0 } });

  useEffect(() => {
    (async () => {
      try {
        if (selectedGroupId != 0) {
          const response = await ApiAmusementGroup.get(selectedGroupId);
          //  if (response.succeeded == true) {
          setValue("id", response.id);
          setValue("backgroundColor", response.backgroundColor);
          setValue("imageUrl", response.imageUrl);
          setValue("indexView", response.indexView);
          setValue("status", response.status);
          setValue("title", response.title);
          setValue("urlName", response.urlName);
          //   }
        }
      } catch (error) {
        console.log("error :>> ", error);
      }
    })();

    return () => { };
  }, []);

  const onSubmit = async (data) => {
    try {
      let response = null;
      if (data.id <= 0) response = await ApiAmusementGroup.create(data);
      else response = await ApiAmusementGroup.update(data.id, data);

      if (response.succeeded == true) document.getElementById("submitButton").click();


      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  return (
    <div>
      <div className="card-body pt-3 pb-0">
        {/* { <Modal onHide={handleClose} show={showModalGroup} >
        <Modal.Header closeButton onClick={handleClose}>
          <Modal.Title id="contained-modal-title-vcenter">

            <p className=" mr-4 mt-0 pt-0">شهر مورد نظر خود را انتخاب نمایید</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-0 py-0 rounded-4 my-0 ">
      ffffff

        </Modal.Body>
      </Modal> } */}
        {/* Start Modal */}
        <Modal centered onHide={handleClose} show={showModalGroup}>
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                {selectedGroupId != 0 ? " ویرایش دسته  " : " ایجاد دسته جدید"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Col xs="12">
                <Row>
                  <Col xs="12">
                    <Controller
                      name="title"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="عنوان"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onInput={onChange}
                        />
                      )}
                    />
                    {errors.title && <span className="text-danger">لطفا عنوان را وارد نمایید</span>}
                  </Col>
                  <Col xs="12">
                    <Controller
                      name="urlName"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="UrlName"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onInput={onChange}
                        />
                      )}
                    />
                    {errors.urlName && <span className="text-danger">لطفا UrlName را وارد نمایید</span>}
                  </Col>
                  <Col xs="12">
                    <Controller
                      name="imageUrl"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="آدرس عکس"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onInput={onChange}
                        />
                      )}
                    />
                    {errors.imageUrl && <span className="text-danger">لطفا آدرس عکس را وارد نمایید</span>}
                  </Col>
                  <Col xs="12">
                    <Controller
                      name="backgroundColor"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="backgroundColor"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onInput={onChange}
                        />
                      )}
                    />
                    {errors.backgroundColor && <span className="text-danger">لطفا backgroundColor را وارد نمایید</span>}
                  </Col>
                  <Col xs="12">
                    <Controller
                      name="indexView"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="ترتیب نمایش"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onInput={(e) => {
                            if (e.target?.value && !numberRegex.test(e.target?.value)) {
                              e.target.value = getValues("indexView")
                              return
                            }
                            onChange(e)
                          }}
                        />
                      )}
                    />
                    {errors.indexView && <span className="text-danger">لطفا ترتیب نمایش را وارد نمایید</span>}
                  </Col>
                  <Col xs="12">
                    <FormControlLabel
                      control={
                        <Controller
                          control={control}
                          name={"status"}
                          render={({
                            field: { onChange, onBlur, value, name, ref },
                            fieldState: { invalid, isTouched, isDirty, error },
                          }) => (
                            <Checkbox
                              color="primary"
                              onBlur={onBlur}
                              onChange={onChange}
                              checked={value || false}
                              inputRef={ref}
                            />
                          )}
                        />
                      }
                      label="فعال"
                    />
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" type="submit" disabled={isSubmitting}>
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon /> ذخیره
              </Button>
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon /> بستن
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div>
  );
};

export default CreateOrEditAmusementGroup;
